((app, ng) => {
    app.directive("infiniteScroll", ["$document", function($document) {
        return {
            restrict: "A",
            scope: {
                infiniteScroll: "&"
            },
            link: ($scope) => {
                let root = $document[0].getElementsByTagName("root");
                ng.element(root).bind("scroll", () => {
                    if (root[0].scrollTop + root[0].offsetHeight >= root[0].scrollHeight) {
                        $scope.$apply($scope.infiniteScroll);
                    }
                });
            }
        };
    }]);
})(window.app, window.angular);
